export default __webpack_public_path__ + "static/media/stockeer3.6ba56d52.png";